<!--
  REV-21360 — closing workspace header (pure view).
-->
<div class="wsh" data-testid="workspace-header">
    <!-- LOADING — placeholder bars for the blocks `sections` asks for; no actions. -->
    <div class="wsh-loading" data-testid="workspace-header-loading" *ngIf="loading">
        <div class="wsh-loading__top">
            <div class="wsh-skeleton wsh-skeleton--path" *ngIf="wantsPath" aria-hidden="true"></div>
            <div class="wsh-skeleton wsh-skeleton--actions" *ngIf="hasActions" aria-hidden="true"></div>
        </div>
        <div class="wsh-loading__tabs" *ngIf="wantsTabs">
            <div class="wsh-skeleton wsh-skeleton--tabs" aria-hidden="true"></div>
        </div>
    </div>

    <!-- EMPTY — just the frame of the header, no hint text. -->
    <div class="wsh-empty" data-testid="workspace-header-empty" *ngIf="!loading && !error && isEmpty"></div>

    <!--
      HEADER ROW — path on the left, ERP button on the right. The light divider belongs to this
      row. On error the path stays, the actions disappear.
    -->
    <div class="wsh-top" *ngIf="!loading && (hasPath || (hasActions && !error))">
        <ham-button
            class="wsh-back"
            data-testid="workspace-header-back"
            *ngIf="back as target"
            variant="white"
            outline
            size="sm"
            icon="assets/hamIcons/chevron-left.svg"
            (buttonClick)="onBackClick(target.id)"
        >
            {{ target.label }}
        </ham-button>

        <div class="wsh-path" data-testid="workspace-header-path" *ngIf="hasPath">
            <aum-breadcrumb [items]="crumbItems"></aum-breadcrumb>
        </div>

        <ham-button
            class="wsh-erp"
            data-testid="workspace-header-erp"
            *ngIf="hasActions && !error"
            variant="white"
            (buttonClick)="onErpClick()"
        >
            <span class="wsh-erp__body">
                <!-- The connected system, so the button says WHERE it pulls from. Omitted entirely when
                     nothing is connected — a generic placeholder logo would claim a connection. -->
                <img
                    class="wsh-erp__vendor"
                    data-testid="workspace-header-erp-vendor"
                    *ngIf="erpVendor as vendor"
                    [src]="vendor.logoSrc"
                    [alt]="vendor.name"
                />
                <span class="wsh-erp__lines">
                    <span class="wsh-erp__label">{{ 'aumico_abcp_header_erp_refresh' | i18next }}</span>
                    <!--
                        Always a sub-line. It used to disappear when nothing had been pulled yet, which
                        reads as "no information" rather than as "never" — and those are different.
                    -->
                    <span class="wsh-erp__sub" data-testid="workspace-header-erp-sub">
                        <!--
                            The same formatting the integration sync cards use — date AND time, local
                            timezone. Not `timeAgo`: that pipe has HOUR granularity, so everything under
                            an hour reads "jetzt" and a pull from 55 minutes ago is indistinguishable
                            from one that just finished. "When did we last pull" is a fact people
                            compare precisely, so it gets a timestamp.
                        -->
                        <ng-container *ngIf="lastSync as sync; else neverSynced">{{
                            sync | dateLocale : 0 : null : true : true
                        }}</ng-container>
                        <ng-template #neverSynced>{{ 'aumico_abcp_header_erp_never' | i18next }}</ng-template>
                    </span>
                </span>
                <span class="ham-icon wsh-erp__icon" aria-hidden="true"><i class="rotate-90-outline-icon"></i></span>
            </span>
        </ham-button>
    </div>

    <!-- ERROR — partial outage: a plain red sentence instead of the tab bar. -->
    <div class="wsh-error" data-testid="workspace-header-error" *ngIf="!loading && error">
        {{ 'aumico_abcp_header_error' | i18next }}
    </div>

    <!-- TAB BAR — own markup (counter pill), search field docked to the right. -->
    <div class="wsh-tabs" data-testid="workspace-header-tabs" *ngIf="!loading && !error && hasTabs">
        <nav class="wsh-tablist">
            <button
                type="button"
                class="wsh-tab"
                data-testid="workspace-header-tab"
                *ngFor="let tab of tabItems; trackBy: trackByTabId"
                [attr.data-tab-id]="tab.id"
                [attr.aria-current]="tab.id === activeTabId ? 'page' : null"
                [class.is-active]="tab.id === activeTabId"
                (click)="onTabClick(tab.id)"
            >
                <ng-container *ngIf="tabLabelKey(tab.id) | i18next as label">
                    <span class="wsh-tab__label" [attr.data-label]="label">{{ label }}</span>
                </ng-container>
                <span class="wsh-tab__count" data-testid="workspace-header-tab-count" *ngIf="hasCount(tab)">{{
                    tab.count
                }}</span>
            </button>
        </nav>

        <ng-container *ngFor="let tabId of searchTabs; trackBy: trackBySelf">
            <ham-filter
                class="wsh-search"
                data-testid="workspace-header-search"
                [placeholder]="searchPlaceholderKey(tabId) | i18next"
                [hasFilterButton]="false"
                [autoEmit]="true"
                (filter)="onSearch($event)"
            ></ham-filter>
        </ng-container>
    </div>

    <!-- CONTENT SLOT — the page puts the detail screen of the active tab here. -->
    <div class="wsh-content" data-testid="workspace-header-content">
        <ng-content></ng-content>
    </div>
</div>
